import { render } from "./PaymentSettings.vue?vue&type=template&id=006b52b2&scoped=true&ts=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts"

import "./PaymentSettings.vue?vue&type=style&index=0&id=006b52b2&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006b52b2"]])

export default __exports__